/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["img.svg-icon[_ngcontent-%COMP%]{max-width:14px;max-height:14px}.clipboard[_ngcontent-%COMP%]{padding-left:.3em;max-width:1000px}.link[_ngcontent-%COMP%]{overflow-wrap:break-word}"];
export { styles as styles };
